module.exports = __webpack_public_path__ + "img/Pic_Text_FORUM_Title.f5e3323c.png";